import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import { cn } from "@/lib/utils";
import type { Language } from "@/i18n/translations";

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Only route pair whose language lives in the URL itself (two genuinely
  // translated, separately indexable landing pages with reciprocal hreflang).
  const BRIEF_PATHS: Record<Language, string> = {
    de: "/architektur-brief",
    en: "/architecture-brief",
  };

  // The language switch is a pure client-side toggle on the SAME URL.
  // We deliberately do NOT write ?lang=… into the address bar and never
  // navigate to a parallel path: both produced duplicate URLs in Search
  // Console ("Page with redirect" / "Alternative page with proper canonical").
  const handleSelect = (next: Language) => {
    setLang(next);
    if (pathname === BRIEF_PATHS.de || pathname === BRIEF_PATHS.en) {
      if (pathname !== BRIEF_PATHS[next]) navigate(BRIEF_PATHS[next]);
    }
  };

  return (
    <div className="flex items-center rounded-full border border-border text-xs font-medium overflow-hidden">
      <button
        onClick={() => handleSelect("de")}
        aria-label="Sprache auf Deutsch umstellen"
        className={cn(
          "px-2.5 py-1 transition-colors",
          lang === "de"
            ? "bg-primary text-primary-foreground"
            : "text-foreground/70 hover:text-foreground"
        )}
      >
        DE
      </button>
      <button
        onClick={() => handleSelect("en")}
        aria-label="Switch language to English"
        className={cn(
          "px-2.5 py-1 transition-colors",
          lang === "en"
            ? "bg-primary text-primary-foreground"
            : "text-foreground/70 hover:text-foreground"
        )}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
